import React, { useEffect, useCallback, useState} from 'react';
import ParametersMapper from './ParametersMapper.js';
import Documented from 'components/help/Documented.js';
import CheckboxParameter from './CheckboxParameter.js';
import Dropdown from 'react-dropdown';
import AccumulatorMapper from './AccumulatorMapper.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {connect} from 'react-redux';
import {FORWARD, FORWARD_REVERSE, FORWARD_STAY, ADD, MULTIPLY} from 'constants/accumulator-modes.js';
import '../../Accumulator.scss';

const MODE_OPTIONS = [
    {label: "Forward", value: FORWARD},
    {label: "Forward/Reverse", value: FORWARD_REVERSE},
    {label: "Forward/Stay", value: FORWARD_STAY},
];

const OPERATION_PARAMETER_OPTIONS = [
    {label: "Add", value: ADD},
    {label: "Multiply", value: MULTIPLY},
];

const AccumulatorComponent = ({effect, isDraggable, sequencerEngine, mode, operation}) => { 
    let [parameters, setParameters] = useState(effect._parameters);
    if (!effect.isEnabled()) {
        return (<div></div>);
    }

    let max = 1;
    let min = 0;
    for (let parameter of parameters) {
        if (!parameter) {
            continue;
        }
        if (parameter.min < min) {
            min = parameter.min;
        }
        if (parameter.max > max) {
            max = parameter.max;
        }
    }
    return (
        <div className="accumulator">
          <div className="acc-column">
          <Documented element={effect.modeParameter} className="synced-parameter">
            <span>Limit Mode: </span>
            <Dropdown
              placeholder="Limit Mode"
              options={MODE_OPTIONS}
              value={MODE_OPTIONS.find(x => x.value === mode)}
              onChange={(o) => effect.modeParameter.set(o.value)}
            />
          </Documented>
          <EffectParameterSlider
            name={'Accumulator'}
            parameter={effect.accumulatorValueParameter}
            isParameter={true}
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            step={0.001}
            min={min}
            max={max}/>
          <EffectParameterSlider
            name={'Limit'}
            parameter={effect.limitParameter}
            isParameter={true}
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            step={0.001}
            min={0}
            max={max - min}/>
          <EffectParameterSlider
            name={'Ramp Time'}
            parameter={effect.rampTimeParameter}
            isParameter={true}
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            unit="ms"
            step={1}
            min={1}
            max={3000}/>
          <CheckboxParameter name="Reset on step 1" parameter={effect.resetAtZeroParameter}/>
          </div>
          <ParametersMapper isDraggable={isDraggable} effect={effect}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      mode: props.effect.modeParameter.get(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccumulatorComponent);
